<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.contact_admins") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="validateFormInputs">
          <div class="row">
            <div class="row justify-content-center">
              <div class="col-l2">
                <div class="add_another" @click="addRow()">
                  <i class="fas fa-plus"></i>
                </div>
              </div>

              <ValidationProvider
                v-for="(item, index) in phones"
                :key="'phone-' + index"
                :name="$t('PLACEHOLDERS.phone') + ' ' + (index + 1)"
                rules="phone"
                v-slot="{ errors }"
                class="col-lg-6 col-12"
              >
                <div class="item d-flex align-items-center">
                  <base-input
                    class="w-100"
                    type="number"
                    :placeholder="$t('PLACEHOLDERS.phone')"
                    v-model.trim="item.phone"
                    :errors="errors[0]"
                  />
                  <div class="all_actions">
                    <span
                      class="add_another remove_phone_number"
                      @click="removeRow(index)"
                    >
                      <i class="fas fa-minus"></i>
                    </span>
                  </div>
                </div>
              </ValidationProvider>
            </div>

            <!-- WhatsApp -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.WhatsApp_contact')"
              rules="phone"
              v-slot="{ errors }"
              class="col-lg-6 col-12"
            >
              <base-input
                type="number"
                :placeholder="$t('PLACEHOLDERS.WhatsApp_contact')"
                v-model.trim="data.WhatsApp_contact"
                :errors="errors[0]"
              />
            </ValidationProvider>

            <!-- Email -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.email')"
              rules="email"
              v-slot="{ errors }"
              class="col-lg-6 col-12"
            >
              <base-input
                type="text"
                :placeholder="$t('PLACEHOLDERS.email')"
                v-model.trim="data.email"
                @input="data.email = allowEnglishNumbersSymbols($event)"
                :errors="errors[0]"
              />
            </ValidationProvider>

            <!-- Facebook Link -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.facebook_link')"
              rules="url"
              v-slot="{ errors }"
              class="col-lg-6 col-12"
            >
              <base-input
                type="text"
                :placeholder="$t('PLACEHOLDERS.facebook_link')"
                @input="data.facebook_link = allowEnglishNumbersSymbols($event)"
                v-model.trim="data.facebook_link"
                :errors="errors[0]"
              />
            </ValidationProvider>

            <!-- Instagram Link -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.insta_link')"
              rules="url"
              v-slot="{ errors }"
              class="col-lg-6 col-12"
            >
              <base-input
                type="text"
                :placeholder="$t('PLACEHOLDERS.insta_link')"
                @input="
                  data.instagram_link = allowEnglishNumbersSymbols($event)
                "
                v-model.trim="data.instagram_link"
                :errors="errors[0]"
              />
            </ValidationProvider>

            <!-- Snapchat Link -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.snap_link')"
              rules="url"
              v-slot="{ errors }"
              class="col-lg-6 col-12"
            >
              <base-input
                type="text"
                :placeholder="$t('PLACEHOLDERS.snap_link')"
                @input="data.snapchat_link = allowEnglishNumbersSymbols($event)"
                v-model.trim="data.snapchat_link"
                :errors="errors[0]"
              />
            </ValidationProvider>

            <!-- TikTok Link -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.tiktok_link')"
              rules="url"
              v-slot="{ errors }"
              class="col-lg-6 col-12"
            >
              <base-input
                type="text"
                :placeholder="$t('PLACEHOLDERS.tiktok_link')"
                @input="data.tiktok_link = allowEnglishNumbersSymbols($event)"
                v-model.trim="data.tiktok_link"
                :errors="errors[0]"
              />
            </ValidationProvider>

            <!-- Twitter Link -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.twitter_link')"
              rules="url"
              v-slot="{ errors }"
              class="col-lg-12 col-12"
            >
              <base-input
                type="text"
                @input="data.twitter_link = allowEnglishNumbersSymbols($event)"
                :placeholder="$t('PLACEHOLDERS.twitter_link')"
                v-model.trim="data.twitter_link"
                :errors="errors[0]"
              />
            </ValidationProvider>
   
            <!-- Submit -->
            <div class="btn_wrapper">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
                :disabled="invalid || isWaitingRequest"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
import allowLanguageMinxin from "@/mixins/allowLanguageMinxins.js";

export default {
  name: "GeneralSettings",
  mixins: [allowLanguageMinxin],

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        WhatsApp_contact: null,
        linkedIn_link: null,
        twitter_link: null,
        tiktok_link: null,
        snapchat_link: null,
        instagram_link: null,
        facebook_link: null,
        android: null,
        ios: null,
        email: null,
      },
      // End:: Data Collection To Send

      phones: [
        {
          phone: "",
        },
      ],
    };
  },

  methods: {
    addRow() {
      this.phones.push({ phone: "" });
    },

    removeRow(index) {
      this.phones.splice(index, 1);
    },

    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `settings?key=contact`,
        });
        // Start:: Set Data

        // Transform the API response
        this.phones =
          res.data.data[0]?.value?.phones?.map((phone) => ({
            phone: phone,
          })) || [];
        if (this.phones.length === 0) {
          this.phones.push({ phone: "" });
        }
        this.data.WhatsApp_contact = res.data.data[0]?.value?.whatsapp;
        this.data.twitter_link = res.data.data[0]?.value?.x;
        this.data.facebook_link = res.data.data[0]?.value?.facebook;
        this.data.instagram_link = res.data.data[0]?.value?.instagram;
        this.data.tiktok_link = res.data.data[0]?.value?.tiktok;
        this.data.snapchat_link = res.data.data[0]?.value?.snapchat;
        this.data.email = res.data.data[0]?.value?.email;
        this.data.android = res.data.data[0]?.value?.social?.play_store;
        this.data.ios = res.data.data[0]?.value?.social?.app_store;

        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Edit

    // Start:: Submit Form
    async submitForm() {
      this.isWaitingRequest = !this.isWaitingRequest;

      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("key", "contact");
      this.phones.forEach((element) => {
        if (element.phone) {
          REQUEST_DATA.append(`value[phones][]`, element.phone);
        }
      });
      if (this.data.WhatsApp_contact) {
        REQUEST_DATA.append("value[whatsapp]", this.data.WhatsApp_contact);
      }
      if (this.data.tiktok_link) {
        REQUEST_DATA.append("value[tiktok]", this.data.tiktok_link);
      }
      if (this.data.facebook_link) {
        REQUEST_DATA.append("value[facebook]", this.data.facebook_link);
      }
      if (this.data.snapchat_link) {
        REQUEST_DATA.append("value[snapchat]", this.data.snapchat_link);
      }
      if (this.data.twitter_link) {
        REQUEST_DATA.append("value[x]", this.data.twitter_link);
      }
      if (this.data.instagram_link) {
        REQUEST_DATA.append("value[instagram]", this.data.instagram_link);
      }
      if (this.data.android) {
        REQUEST_DATA.append("value[play_store]", this.data.android);
      }
      if (this.data.ios) {
        REQUEST_DATA.append("value[app_store]", this.data.ios);
      }
      if (this.data.email) {
        REQUEST_DATA.append("value[email]", this.data.email);
      }
      // REQUEST_DATA.append("value[linkedin]", this.data.linkedIn_link);

      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `settings?key=contact`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.submitForm();
    },
    // End:: validate Form Inputs
  },

  created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.item {
  gap: 10px;
}

.all_action {
  display: flex;
  gap: 15px;
}

.add_another {
  border: none;
  padding: 8px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--light_gray_clr);
  border-radius: 50%;
  font-size: 18px;
  color: var(--light_gray_clr);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: auto;

  .fa-trash {
    color: #ff2159;
    cursor: pointer;
  }
}
</style>
